import comment from 'iztech-design-system-neo/dist/system/i18n/jp/comment'

export default {
  ...comment,
  MSG_COMMENT_SUCCESS: 'システムはご意見を受け取りました。',
	MSG_COMMENT_SUCCESS_AND_WAIT_APPROVAL: 'システムはご意見を受け取りました。管理者が承認するのをご待ちください。',
	MSG_COMMENT_FAIL: 'システムはご意見を受け取りませんでした。後でお試しください。',
	MSG_COMMENT_LOADING: 'システムはご意見を受け取っています。しばらくお待ちください。',
}